import React, { useEffect, useState } from 'react';
import "./project.css";
import { FaUserGraduate, FaBriefcase, FaHandshake, FaTrophy } from "react-icons/fa";

import AOS from "aos";
import "aos/dist/aos.css";

function Project() {
  const targetValues = { projects: 502, experts: 10, cities: 400, designs: 95 };
  const duration = 2000;
  const frameRate = 60;
  const totalFrames = (duration / 1000) * frameRate;

  const [counts, setCounts] = useState({
    projects: 0,
    experts: 0,
    cities: 0,
    designs: 0
  });

  // ✅ Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
    });
  }, []);

  // Counter Animation
  useEffect(() => {
    let frame = 0;

    function animateCount() {
      frame++;
      setCounts({
        projects: Math.min(Math.ceil((frame / totalFrames) * targetValues.projects), targetValues.projects),
        experts: Math.min(Math.ceil((frame / totalFrames) * targetValues.experts), targetValues.experts),
        cities: Math.min(Math.ceil((frame / totalFrames) * targetValues.cities), targetValues.cities),
        designs: Math.min(Math.ceil((frame / totalFrames) * targetValues.designs), targetValues.designs)
      });

      if (frame < totalFrames) {
        requestAnimationFrame(animateCount);
      }
    }

    requestAnimationFrame(animateCount);
  }, []);

  return (
    <div className="other-details bgGray">
      <div className="container-fluid main-cf">
        <ul>

          {/* 1️⃣ Item */}
          <li data-aos="fade-up" data-aos-delay="0">
            <figure>
              <FaUserGraduate size={45} color="#d11111" />
            </figure>
            <div>
              <label>{counts.projects}+</label>
              <span>Successfully Trained</span>
            </div>
          </li>

          {/* 2️⃣ Item */}
          <li data-aos="fade-up" data-aos-delay="100">
            <figure>
              <FaBriefcase size={45} color="#d11111" />
            </figure>
            <div>
              <label>{counts.experts}+</label>
              <span>Projects</span>
            </div>
          </li>

          {/* 3️⃣ Item */}
          <li data-aos="fade-up" data-aos-delay="200">
            <figure>
              <FaHandshake size={45} color="#d11111" />
            </figure>
            <div>
              <label>{counts.cities}+</label>
              <span>Partnered Clients</span>
            </div>
          </li>

          {/* 4️⃣ Item */}
          <li data-aos="fade-up" data-aos-delay="300">
            <figure>
              <FaTrophy size={45} color="#d11111" />
            </figure>
            <div>
              <label>{counts.designs}%</label>
              <span>Placement Rewards</span>
            </div>
          </li>

        </ul>
      </div>
    </div>
  );
}

export default Project;
